import {GetFormattedNumber} from "../../../../../Helpers/Formatters";
import {EsignerRole, OwnerType, AccountTypes} from "../../../../../Common/Constant";
import {getESignerContactValues, getEsignPrefillData, isMissingPhoneOrEmail, setPhoneAndEmail} from "./eSignerFunctions";

const getOwnerInfo = (formState, clientDataObj) => {
  const { pages : { retrieveAccount}} = formState;
  const  {owners,soleProprieter} = clientDataObj;
  const {clientData, selectedOwner, jointOwner} = retrieveAccount;

  if (!owners || owners.length < 1)
    return null;

  let ownerArray = [];

  let filteredOwners = [...owners];
  soleProprieter.forEach((element) => {
    filteredOwners.push(element);
  })

  const isJointAccount = clientData.accountType && clientData.accountType.toLowerCase() === AccountTypes.JOINT;

  // if account is joint and policy ownership is also joint
  const isJointPolicyOwner = isJointAccount &&
    (retrieveAccount.policyOwnership && retrieveAccount.policyOwnership.toLowerCase() === AccountTypes.JOINT);

  // if account is joint and policy ownership is individual
  const isIndividualPolicyOwner = isJointAccount &&
    (retrieveAccount.policyOwnership && retrieveAccount.policyOwnership.toLowerCase() === AccountTypes.INDIVIDUAL);

  // in cases where account is joint and ownership type is individual we only want the selected owner
  if (isIndividualPolicyOwner)
  filteredOwners = owners.filter(x => x.covrGeneratedID === selectedOwner.covrGeneratedID)

  if (clientData.accountType && (clientData.accountType.toLowerCase() === AccountTypes.PARTNERSHIP || clientData.accountType.toLowerCase() === AccountTypes.UNINCORPORATED && clientData.accountSubclass.toLowerCase() === AccountTypes.SOLE_PROPRIETOR) && (selectedOwner.ownerType && selectedOwner.ownerType.toLowerCase() === OwnerType.ORGANIZATION)) {
    filteredOwners = filteredOwners.filter(owner => !owner.ownerType || owner.ownerType.toLowerCase() !== OwnerType.ORGANIZATION);
  } else {
    if(isJointPolicyOwner)
      filteredOwners = filteredOwners.filter(owner => (!owner.ownerType || (owner.ownerType && owner.ownerType.toLowerCase() !== OwnerType.ORGANIZATION)) && (owner.covrGeneratedID === jointOwner || owner.isPrimary === 'Y'))
    else
      filteredOwners = filteredOwners.filter(owner => (!owner.ownerType || (owner.ownerType && owner.ownerType.toLowerCase() !== OwnerType.ORGANIZATION)) && owner.covrGeneratedID === selectedOwner.covrGeneratedID);
  }

  filteredOwners.forEach((owner, index) => {

    const roleName = isJointPolicyOwner ?
      (owner.covrGeneratedID  === jointOwner ? EsignerRole.JOINT_OWNER : EsignerRole.PRIMARY_OWNER) : EsignerRole.OWNER;

    let eSigner = {};
    eSigner.firstName = owner.firstName;
    eSigner.lastName = owner.lastName;
    eSigner.role = roleName;

    const ownerContact = getESignerContactValues(owner);

    let emailList = [];
    let phoneList = [];

    // set dropdown values
    ownerContact.emails.forEach((element, index) => {
      emailList.push({label: element, value: element})
    })
    ownerContact.phones.forEach((element, index) => {
      phoneList.push({label: GetFormattedNumber(element), value: element})
    })

    eSigner.emailList = emailList;
    eSigner.phoneList = phoneList;

    const { prefillPhone, prefillEmail, prefillAuthentication } = getEsignPrefillData(roleName, formState, index);
    const { phoneVal, emailVal } = setPhoneAndEmail(emailList, phoneList);
    eSigner.phone = prefillPhone || phoneVal;
    eSigner.email = prefillEmail || emailVal;
    eSigner.authentication = prefillAuthentication;
    eSigner.missingContact = isMissingPhoneOrEmail(emailList, phoneList);

    ownerArray.push(eSigner);
  });

  return ownerArray;
}

export default getOwnerInfo;




// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/getOwnerInfo.js